import React from "react";
import GalleryVideoDetailsPlayer from "../../pages/events/ViewPhoto/GalleryVideoDetailsPlayer";

const SliderVideo = ({ activeItemIndex, boomerangShareDetails, dataSlider }) => (
  <GalleryVideoDetailsPlayer
    activeItemIndex={activeItemIndex}
    dataSlider={dataSlider}
    directory="video"
    fileKey="event_video"
    initialDetails={boomerangShareDetails}
    title="Boomerang details"
  />
);

export default SliderVideo;
